<template>
  <div class="comment-item">
    <div class="pic">
      <img :data-src="data.user.logoUrl | imageUrl" :src="data.user.logoUrl | imageUrl('?imageView2/1/w/80/h/80', '//www.zai-art.com/appwrapper_dist/appDefaultImage/user.png')" />
    </div>
    <div class="content">
      <div class="hd">
        <div class="hd-left">
          <span class="name">{{data.user.nickName}}</span>
          <span class="time">{{data.noteTag.createTime | formatDateTime}}</span>
        </div>
        <div class="hd-right">
          <span class="flower" @click="onFlower">{{data.goodCount}}</span>
          <span class="replay-btn" @click="onReply">回复</span>
        </div>
      </div>
      <div class="bd">
        <div class="comment-content" v-html="resolveCotent(data.noteTag.content)"></div>
        <div class="comment-pic" v-for="photo in data.photos" :key="photo.id">
          <img :data-src="photo.imageUrl | imageUrl" :src="photo.imageUrl | imageUrl('?imageView2/2/w/330')" :style="photo.imageWidth >= photo.imageHeight ? 'width:165px;' : 'height:165px;' " />
        </div>
      </div>
    </div>
    <el-dialog custom-class="note-dialog" :visible.sync="dialogVisible" width="340px">
      <div class="qrcode"></div>
      <p>扫码立即下载</p>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'CommentItem',
  props: { data: Object },
  data: () => ({
    dialogVisible: false
  }),
  methods: {
    // 内容解析@用户
    resolveCotent(value = '') {
      return value.replace(/@\[([\s|\S]*?),([\s|\S]*?)\]/gi, '<a data-id="$2">@$1</a>')
    },
    // 送花
    onFlower() {
      this.dialogVisible = true
    },
    // 回复
    onReply() {
      this.dialogVisible = true
    }
  }
}
</script>
<style>
.comment-item {
  clear: both;
  margin-top: 30px;
  overflow: hidden;
}
.comment-item:first-child {
  margin-top: 0;
}
.comment-item .pic {
  float: left;
  width: 40px;
  height: 40px;
  border: 1px solid #dadada;
  border-radius: 50%;
  overflow: hidden;
}
.comment-item .pic img {
  width: 100%;
}
.comment-item .content {
  margin-left: 54px;
}
.comment-item .hd {
  height: 40px;
}
.comment-item .hd-left {
  float: left;
}
.comment-item .hd-right {
  float: right;
}
.comment-item .hd-right .flower {
  display: inline-block;
  background: url('../../../assets/img/icon/flower.png') no-repeat left center;
  background-size: 13px 14px;
  padding-left: 24px;
  font-size: 12px;
  line-height: 40px;
  color: #999;
  cursor: pointer;
}
.comment-item .hd-right .replay-btn {
  display: inline-block;
  height: 12px;
  margin: 14px 0 14px 20px;
  padding-left: 20px;
  font-size: 12px;
  line-height: 12px;
  color: #999;
  border-left: 1px solid #d8d8d8;
  cursor: pointer;
}
.comment-item .bd {
  clear: both;
  overflow: hidden;
}
.comment-item .content .name {
  display: inline-block;
  font-size: 16px;
  line-height: 40px;
  color: #3c3c3c;
}
.comment-item .content .time {
  padding-left: 10px;
  display: inline-block;
  font-size: 12px;
  line-height: 40px;
  color: #999;
}
.comment-item .comment-content {
  font-size: 14px;
  line-height: 22px;
  color: #666;
}
.comment-item .comment-content a {
  padding-left: 5px;
  color: #1641fd;
  cursor: pointer;
}
.comment-item .comment-pic {
  float: left;
  margin: 10px 10px 0 0;
  width: auto;
  max-width: 165px;
  height: auto;
  max-height: 165px;
}
.comment-item .comment-pic img {
  max-width: 100%;
  max-height: 100%;
}
.note-dialog {
  border-radius: 6px;
}
.note-dialog .el-dialog__body {
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
}
.note-dialog .el-dialog__body .qrcode {
  width: 250px;
  height: 250px;
  margin: 0 auto;
  background: url('../../../assets/img/icon/notes_qrcode.png') no-repeat;
  background-size: contain;
}
.note-dialog .el-dialog__body p {
  padding: 20px 0;
  font-size: 22px;
  color: #666;
  line-height: 22px;
  letter-spacing: 12px;
}
</style>
